import React, {useState} from "react"
import {
    Container,
    IconButton,
    Button,
    Box
} from "@mui/material";
import './ApiKeyDashboard.css'
import AddIcon from '@mui/icons-material/Add';
import {useGetApiKeysQuery} from "../../Redux/api-key-management-api";
import {useSelector} from "react-redux";
import {selectAllApiKeys} from "../../Redux/api-key-management-api";
import {DeleteApiKey} from "../DeleteApiKey/DeleteApiKey";
import {ApiKeyRead} from "../../Models/models";
import {CreateApiKey} from "../CreateApiKey/CreateApiKey";
import {DataGridPremium, GridColDef} from "@mui/x-data-grid-premium";
import {SnackbarMode, useGlobalSnackbar} from "../Snackbar/useGlobalSnackbar";
import CachedSharpIcon from "@mui/icons-material/CachedSharp";

const ApiKeyDashboard = () => {

    const [loaderClass, setLoaderClass] = useState<string>("")

    const {showSnackbar} = useGlobalSnackbar()

    const {isLoading, refetch, isSuccess} = useGetApiKeysQuery()

    const data: ApiKeyRead[] = useSelector(selectAllApiKeys)

    const reload = () => {
        setLoaderClass("reload")
        refetch().then(() => setLoaderClass(''))
        if (isSuccess) {
            showSnackbar('Reloaded', SnackbarMode.SUCCESS)
        } else {
            showSnackbar('Reload failed. Please try again', SnackbarMode.ERROR)
        }
    }

    const [open, setOpen] = useState<boolean>(false)

    const columns: GridColDef[] = [
        {field: 'name', headerName: 'Token Name', minWidth: 300, flex: 2, resizable: false, disableReorder: true, disableExport: true, groupable: false},
        {field: 'creationDate', headerName: 'Creation Date', minWidth: 100, flex: 1, resizable: false, disableReorder: true, disableExport: true, groupable: false, valueFormatter: (value, row) => {
            const date_value =  row.creationDate;
            if (date_value == null) {
                return '';
            }
            const date = new Date(date_value)
            return date.toLocaleString('de-DE')}
        },
        {field: 'delete', headerName: '', width: 80, sortable: false, filterable: false, resizable: false, disableColumnMenu: true, renderCell: (params) => (
            <IconButton>
                <DeleteApiKey apiKey={params.row} />
            </IconButton>
            )}
    ]

    return (
        <>
            <Container maxWidth='xl' sx={{marginTop: '30px'}}>
                <Box display="flex" justifyContent="space-between" alignItems="center" sx={{marginBottom: '30px'}}>
                    <Button onClick={() => setOpen(true)} color="info" variant="contained" startIcon={<AddIcon/>} > Create new Token</Button>
                    <Button onClick={() => reload()} color="secondary" variant="outlined" startIcon={<CachedSharpIcon className={loaderClass}/>} > Reload Tokens</Button>
                </Box>

                <DataGridPremium pagination columns={columns} rows={data} getRowId={(row) => row.apiKeyId} loading={isLoading} showToolbar pageSizeOptions={[5,10,15]} disableAggregation={true} disableColumnPinning={true} disablePivoting={true} disableColumnSelector={true}/>

            </Container>
            <CreateApiKey open={open} setOpen={setOpen}/>
        </>

    )
}

export {ApiKeyDashboard}